import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { loadConfiguration } from '@/config/config';
import VueClipboard from 'vue3-clipboard';
import '@/styles/main.scss';
import i18n from './i18n';

require('typeface-open-sans');
require('typeface-work-sans');
require('typeface-inter');

loadConfiguration().then(() => {
  createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .use(VueClipboard, {
      autoSetContainer: true,
      appendToBody: true
    })
    .mount('#app');
});
